import {
  createListenerMiddleware,
  addListener,
  type TypedStartListening,
  type TypedAddListener,
} from '@reduxjs/toolkit';

import { type RootState, type AppDispatch } from '../redux-utils';

import { localeListener } from './listeners/localeListener';
// import { amplitudeListeners } from '../amplitude/amplitudeListeners';

const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening as TypedStartListening<
  RootState,
  AppDispatch
>;

export const addAppListenersToMiddleware = () => {
  // amplitudeListeners();
  localeListener();
};

export const addAppListener = addListener as TypedAddListener<RootState, AppDispatch>;

export default listenerMiddleware;
